import './Footer.scss';
import TelegramIcon from './icons/tg-icon.svg';
import YoutubeIcon from './icons/youTube-icon.svg';
import OkIcon from './icons/ok-icon.svg';
import VkIcon from './icons/vk-icon.svg';
import { jsx as _jsx } from "react/jsx-runtime";
var socialLinks = [{
        id: 1,
        href: 'https://m.vk.com/',
        label: 'ВКонтакте',
        icon: VkIcon
    }, {
        id: 2,
        href: 'https://www.youtube.com',
        label: 'YouTube',
        icon: YoutubeIcon
    }, {
        id: 3,
        href: 'https://ok.ru/',
        label: 'Одноклассники',
        icon: OkIcon
    }, {
        id: 4,
        href: 'https://web.telegram.org',
        label: 'Telegram',
        icon: TelegramIcon
    }];
var Footer = function Footer() {
    return /*#__PURE__*/ _jsx("footer", {
        className: "footer",
        children: /*#__PURE__*/ _jsx("div", {
            className: "container",
            children: /*#__PURE__*/ _jsx("ul", {
                className: "footer__list",
                children: socialLinks.map(function (_ref) {
                    var id = _ref.id, href = _ref.href, label = _ref.label, Icon = _ref.icon;
                    return /*#__PURE__*/ _jsx("li", {
                        className: "footer__item",
                        children: /*#__PURE__*/ _jsx("a", {
                            href: href,
                            "aria-label": label,
                            className: "footer__link",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/ _jsx(Icon, {
                                className: "footer__icon"
                            })
                        })
                    }, id);
                })
            })
        })
    });
};
export default Footer;
